/* <price-quantity> — multiplies the displayed buy-box price (and its
   compare-at strikethrough) by the selected quantity.

   Wraps the #price-{section} container. Variant switches replace that
   container's innerHTML and then publish PUB_SUB_EVENTS.variantChange,
   so the multiplication re-applies against the freshly stamped data-*
   attributes on the swapped .price root. User quantity edits surface as
   a bubbling 'change' event from .quantity__input (global.js dispatches
   it for the ± buttons too); PUB_SUB_EVENTS.quantityUpdate covers the
   programmatic resets from setQuantityBoundries (init, variant change).
   Amounts are always computed from cents — never parsed from the
   displayed strings. Unit price, installments and volume-pricing notes
   are intentionally left untouched. */

if (!customElements.get('price-quantity')) {
  customElements.define(
    'price-quantity',
    class PriceQuantity extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info') || document;
        this._onChange = (event) => {
          if (event.target.classList && event.target.classList.contains('quantity__input')) this._apply();
        };
        this.root.addEventListener('change', this._onChange);

        this._unsubscribers = [];
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this._unsubscribers.push(subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this._apply()));
          this._unsubscribers.push(
            subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId } }) => {
              if (sectionId === this.dataset.section) this._apply();
            })
          );
        }
        this._apply();
      }

      disconnectedCallback() {
        this.root.removeEventListener('change', this._onChange);
        this._unsubscribers.forEach((unsubscribe) => unsubscribe());
      }

      _quantity() {
        const input =
          this.root.querySelector(`#Quantity-${this.dataset.section}`) || this.root.querySelector('.quantity__input');
        const value = input ? parseInt(input.value, 10) : NaN;
        return Number.isFinite(value) && value > 0 ? value : 1;
      }

      _apply() {
        const price = this.querySelector('.price');
        if (!price) return;
        const cents = parseInt(price.dataset.priceCents, 10);
        if (!Number.isFinite(cents)) return;
        const compareCents = parseInt(price.dataset.compareCents, 10) || 0;
        const quantity = this._quantity();
        const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: price.dataset.currency || 'USD',
        });
        const write = (element, valueCents) => {
          if (element) element.textContent = format.format((valueCents * quantity) / 100);
        };
        write(price.querySelector('.price__regular .price-item--regular'), cents);
        write(price.querySelector('.price__sale .price-item--sale'), cents);
        if (compareCents > 0) write(price.querySelector('.price__sale s.price-item--regular'), compareCents);
      }
    }
  );
}
